module.exports = __webpack_public_path__ + "img/ico_pending.c494a413.svg";